import { render, staticRenderFns } from "./namo.vue?vue&type=template&id=6323f3f4"
import script from "./namo.vue?vue&type=script&lang=js"
export * from "./namo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports